import React, { useState, useEffect } from 'react';
import { useLocation } from '@reach/router';
import { Box, CssBaseline, ThemeProvider } from '@mui/material';
import { CookiesProvider } from 'react-cookie';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import theme from '../../app/theme';
import ModalBlock from '../ModalBlock/ModalBlock';
import SubscriptionModal from '../Modals/SubscriptionModal';
import { CookiesNotification } from '../CookiesNotification/CookiesNotification';

function Layout({ children }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsModalOpen(() => location.hash === '#subscribe');
  }, [location]);

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'optimize.activate' });
  }, []);

  if (typeof window === 'undefined') {
    return null;
  }
  return (
    <ThemeProvider theme={theme}>
      <CookiesProvider>
        <CssBaseline />
        <ModalBlock
          isOpen={isModalOpen}
          handleClose={() => setIsModalOpen(false)}
        >
          <SubscriptionModal />
        </ModalBlock>

        <CookiesNotification />

        <Box
          sx={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
          }}
        >
          <Header />
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              minHeight: 'unset',
              marginTop: 0,
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
            }}
          >
            {children}
          </Box>
          <Footer />
        </Box>
      </CookiesProvider>
    </ThemeProvider>
  );
}

export default Layout;
